<script setup lang="ts">
import { ref, watch } from "vue";
import type { ChatAgent, SessionSubject } from "../api/use-agents";
import SessionChat from "./SessionChat.vue";

const props = defineProps<{
	agent: ChatAgent;
	sessionId?: string | null;
	compact?: boolean;
	wide?: boolean;
	subject?: SessionSubject | null;
	autoNavigate?: boolean;
}>();
const emit = defineEmits<{ sessionStarted: [string] }>();
const chat = ref<{ prefill: (text: string, send?: boolean) => void } | null>(null);
defineExpose({ prefill: (text: string, send?: boolean) => chat.value?.prefill(text, send) });

// A selected conversation owns its stream. Unmount only detaches the viewer;
// the server keeps working and replays the turn when this session is reopened.
const generation = ref(0);
let current = props.sessionId ?? null;
watch(
	() => props.sessionId ?? null,
	(id) => {
		if (id === current) return;
		current = id;
		generation.value++;
	},
	{ flush: "sync" },
);
function adopt(id: string): void {
	// The session created by this chat is an acknowledgement, not a navigation.
	current = id;
	emit("sessionStarted", id);
}
</script>

<template>
 <SessionChat
  ref="chat"
  :key="`${agent.code}:${subject?.id ?? 'panel'}:${generation}`"
  v-bind="props"
  @session-started="adopt"
 />
</template>
